import { DATA_PERSISTENCE, DATA_APP_VISIBLE, DATA_POWERED_BY, DATA_ANIMATION, DATA_HIW, DATA_HEADER_BUTTONS_HOVER, DATA_FAB_BUTTON_STYLE, DATA_FAB_CLOSE_ICON, DATA_FIXED_MANDATORY_ATTRIBUTES, DATA_RIGHT_OFFSET, DATA_BOTTOM_OFFSET, DATA_EXPANDABLE_FAB, DATA_REACH_OUT_MODE, DATA_NEW_CONVERSATION_MODE } from "./ClientContext";
export var getOptionConfigOptions = function getOptionConfigOptions() {
  return [{
    attributeKey: DATA_PERSISTENCE,
    classProp: "_persistenceEnabled",
    defaultValue: true
  }, {
    attributeKey: DATA_APP_VISIBLE,
    classProp: "_appVisible",
    defaultValue: true
  }, {
    attributeKey: DATA_POWERED_BY,
    classProp: "_poweredBy",
    defaultValue: true
  }, {
    attributeKey: DATA_ANIMATION,
    classProp: "_animation",
    defaultValue: true
  }, {
    attributeKey: DATA_HIW,
    classProp: "_hiwMode",
    defaultValue: "optional",
    valueExtractor: function valueExtractor(domValue) {
      if (domValue === "mandatory") {
        return "mandatory";
      } else if (domValue === "optional") {
        return "optional";
      } else {
        return "disabled";
      }
    }
  }, {
    attributeKey: DATA_HEADER_BUTTONS_HOVER,
    classProp: "_headerButtonHoverEnabled",
    defaultValue: true
  }, {
    attributeKey: DATA_FAB_BUTTON_STYLE,
    classProp: "_fabButtonStyle",
    defaultValue: "normal",
    valueExtractor: function valueExtractor(domValue) {
      if (domValue === "flat") {
        return "flat";
      } else {
        return "normal";
      }
    }
  }, {
    attributeKey: DATA_FAB_CLOSE_ICON,
    classProp: "_fabCloseButtonStyle",
    defaultValue: "close",
    valueExtractor: function valueExtractor(domValue) {
      if (domValue === "chat") {
        return "chat";
      } else {
        return "close";
      }
    }
  }, {
    attributeKey: DATA_FIXED_MANDATORY_ATTRIBUTES,
    classProp: "_fixedMandatoryAttributes",
    defaultValue: false
  }, {
    attributeKey: DATA_BOTTOM_OFFSET,
    classProp: "_bottomOffset",
    defaultValue: 20,
    valueExtractor: function valueExtractor(domValue) {
      try {
        var offset = Number(domValue);
        return offset;
      } catch (_unused) {
        return 20;
      }
    }
  }, {
    attributeKey: DATA_RIGHT_OFFSET,
    classProp: "_rightOffset",
    defaultValue: "20px",
    valueExtractor: function valueExtractor(domValue) {
      if (!domValue.includes("px")) {
        return "".concat(domValue, "px");
      }

      return domValue;
    }
  }, {
    attributeKey: DATA_EXPANDABLE_FAB,
    classProp: "_expandableFab",
    defaultValue: false
  }, {
    attributeKey: DATA_REACH_OUT_MODE,
    classProp: "_reachOutMode",
    defaultValue: "none",
    valueExtractor: function valueExtractor(domValue) {
      var VALID_VALUES = ["none", "static", "expert"];

      if (VALID_VALUES.includes(domValue)) {
        return domValue;
      }

      return "none";
    }
  }, {
    attributeKey: DATA_NEW_CONVERSATION_MODE,
    classProp: "_newConversationMode",
    defaultValue: "standard",
    valueExtractor: function valueExtractor(domValue) {
      var VALID_VALUES = ["standard", "group-new-tab", "group-same-window"];

      if (VALID_VALUES.includes(domValue)) {
        return domValue;
      }

      return "standard";
    }
  }];
};